<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import SelectCategoriaLeilao from './SelectCategoria'
  import service from '../../../../domain/leiloes/services'
  import {isArray} from 'lodash'

  export default {
    components: {SelectCategoriaLeilao},
    nome: 'novo-leilao',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        leilao: {
//          id: null,
          titulo: null,
          dataAbertura: null,
          dataPublicacao: null,
          automatico: null,
          cobraComissao: null,
          cobraTaxasAdicionais: null,
          syncExtra: {
            codigoInterno: null
          },
          valorComissao: null,
          syncId: null,
          infoRetirada: null,
          infoVisitacao: null,
          instancia: '',
          judicial: null,
          loteado: null,
          destaque: null,
          observacao: null,
          descricao: null,
//          status: null,
          valorTaxaIcms: null,
          valorTaxaIss: null,
          timerPregao: 10,
          tipo: null,
          categoria: '',
          leiloeiro: '',
          local: '',
          semData: false,
          descricaoDestaque: null,
          descricaoDestaqueConfig: {
            fonte: '16px',
            cor: '#ff2600'
          },
          descricaoDestaque2: null,
          descricaoBotao: null,
          habilitarFotoDestaque: false
        },
        dataAbertura: null,
        horaAbertura: null,
        dataPublicacao: null,
        horaPublicacao: null,
        // Configurações
        loadTiposError: false,
        loadTiposText: 'Carregando',
        locais: null,
        leiloeiros: null,
        cadastroError: null,
        atualizadoSucesso: null,
        // timerPregaoC: null,
        tiposLeilao: [
          {label: 'Presencial', value: 1, class: 'btn-primary'},
          {label: 'Online', value: 0, class: 'btn-success'},
          {label: 'Ambos', value: 2, class: 'btn-info'}
        ]
      }
    },
    computed: {
      /* timerPregao: {
       get: function () {
       return this.timerPregaoC
       },
       set: function (newVal) {
       this.timerPregaoC = newVal
       let val = newVal.split(':')
       let minutes = parseInt(val[0])
       this.leilao.timerPregao = (minutes * 60) + parseInt(val[1])
       }
       } */
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {
      dataAbertura: function (val) {
        this.ajustaDataAbertura(val)
      },
      horaAbertura: function (val) {
        this.ajustaHoraAbertura(val)
      },
      dataPublicacao: function (val) {
        this.ajustaDataPublicacao(val)
      },
      horaPublicacao: function (val) {
        this.ajustaHoraPublicacao(val)
      }
    },
    methods: {
      start () {
        this.loadTipos()
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
          service.find(this.$route.params.id)
            .then((response) => {
              this.$loaderOverlay.hide()
              this.leilao = response.data
              // TODO: Ajustar campos
              this.leilao.categoria = (typeof response.data.categoria['id'] !== 'undefined') ? response.data.categoria['id'] : null
              this.leilao.local = (typeof response.data.local['id'] !== 'undefined') ? response.data.local['id'] : null
              this.leilao.leiloeiro = (typeof response.data.leiloeiro['id'] !== 'undefined') ? response.data.leiloeiro['id'] : null
              this.leilao.syncExtra = (response.data.syncExtra !== null) ? response.data.syncExtra : {codigoInterno: null}
              if (!this.leilao.descricaoDestaqueConfig || Array.isArray(this.leilao.descricaoDestaqueConfig) && this.leilao.descricaoDestaqueConfig.length === 0) {
                this.leilao.descricaoDestaqueConfig = {
                  fonte: '16px',
                  cor: '#ff2600'
                }
              }
              this.tranformDate('dataAbertura', 'horaAbertura', this.leilao.dataAbertura.date)
              this.tranformDate('dataPublicacao', 'horaPublicacao', this.leilao.dataPublicacao.date)
              console.log(response)
              this.$nextTick(() => {
                this.ajustaDataAbertura(this.dataAbertura)
                this.ajustaHoraAbertura(this.horaAbertura)
                this.ajustaDataPublicacao(this.dataPublicacao)
                this.ajustaHoraPublicacao(this.horaPublicacao)
              })
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        }
      },
      ajustaDataAbertura (val) {
        this.leilao.dataAbertura = val + ' ' + this.horaAbertura + ':00'
      },
      ajustaHoraAbertura (val) {
        console.log('Ajustando DAB')
        this.leilao.dataAbertura = this.dataAbertura + ' ' + val + ':00'
      },
      ajustaDataPublicacao (val) {
        this.leilao.dataPublicacao = val + ' ' + this.horaPublicacao + ':00'
      },
      ajustaHoraPublicacao (val) {
        this.leilao.dataPublicacao = this.dataPublicacao + ' ' + val + ':00'
      },
      tranformDate (fieldDate, fieldHour, d) {
        let data = new Date(d)
        this[fieldDate] = this.adjustNumber('00', data.getDate()) + '/' + this.adjustNumber('00', data.getMonth() + 1) + '/' + data.getFullYear()
        this[fieldHour] = this.adjustNumber('00', data.getHours()) + ':' + this.adjustNumber('00', data.getMinutes())
      },
      adjustNumber (pad, v) {
        v = String(v)
        return pad.substring(0, pad.length - v.length) + v
      },
      loading (v) {
        this.isLoading = !!v
      },
      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      loadTipos () {
        this.loadTiposError = false
        this.locais = null
        this.leiloeiros = null
        this.loadTiposText = 'Carregando'
        service.buscaTipos().then((response) => {
          this.loadTiposText = 'Selecione'
          this.locais = response.data.locais
          this.leiloeiros = response.data.leiloeiros
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      submit () {
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando leilão...')
        }, 1000)
        service.cadastro(this.leilao, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização do leilão criado
              this.$router.push({name: 'leiloes.visualizar', params: {id: response.data.id}})
            }
          }
          // File
          let necessarySendForm = false
          let formData = new FormData()
          let imagemDestaque = document.querySelector('#fotoDestaque')
          if (typeof imagemDestaque.files[0] !== 'undefined') {
            if (imagemDestaque.files[0] !== null) {
              necessarySendForm = true
              formData.append('fotoDestaque', imagemDestaque.files[0], imagemDestaque.files[0].name)
            }
          }
          if (necessarySendForm) {
            window.setTimeout(() => {
              this.$loaderOverlay.message('Fazendo upload dos arquivos...')
            }, 1000)
            service.uploadArquivosLeilao(response.data.id, formData)
              .then((response) => {
                callbackEnd()
              })
              .catch((response) => {
                window.alert('Falha ao fazer o upload dos arquivos do leilão.')
                callbackEnd()
              })
          } else {
            callbackEnd()
          }
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <div>
    <div>
      <div class="bg-light lter b-b wrapper-md">
        <h1 class="m-n font-thin h3">Cadastro de Leilão</h1>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar o leilão, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
              <div class="font-bold">Atualizado com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">
              <div class="clearfix">
                <div class="col-lg-6 col-md-12">
                  <div class="form-group">
                    <div class="col-lg-offset-2 col-lg-10">
                      <span class="help-block m-b-none">Configure o leilão</span>
                    </div>
                  </div>
                  <div class="line line-dashed b-b line-lg pull-in"></div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Tipo</label>
                    <div class="col-lg-10">
                      <u-button-group v-model="leilao.tipo" :options="tiposLeilao"></u-button-group>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Judicial</label>
                    <div class="col-lg-10">
                      <label class="i-switch bg-warning m-t-xs m-r">
                        <input type="checkbox" v-model="leilao.judicial">
                        <i></i>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Destaque</label>
                    <div class="col-lg-10">
                      <label class="i-switch bg-warning m-t-xs m-r">
                        <input type="checkbox" v-model="leilao.destaque">
                        <i></i>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Classificação</label>
                    <div class="col-lg-10">
                      <select-categoria-leilao v-model="leilao.categoria"></select-categoria-leilao>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Local</label>
                    <div class="col-lg-10">
                      <select v-model="leilao.local" class="form-control w-auto w-full-xs">
                        <option disabled value="">{{loadTiposText}}</option>
                        <option v-for="local in locais" v-bind:value="local.id">
                          {{ local.nome }}
                        </option>
                      </select>
                      <a v-if="loadTiposError" class="btn text-danger" @click="loadTipos">Não foi possível carregar. Tente novamente</a>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Instância</label>
                    <div class="col-lg-10">
                      <select v-model="leilao.instancia" class="form-control w-auto w-full-xs">
                        <option disabled value="">Selecione</option>
                        <option value="1">Leilão Único</option>
                        <option value="2">1º Leilão</option>
                        <option value="3">2º Leilão</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Data de Publicação</label>
                    <div class="col-lg-10">
                      <input placeholder="dd/mm/yyyy" class="form-control w-full-xs w-sm " v-model="dataPublicacao"
                             v-mask="'##/##/####'"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Hora de Publicação</label>
                    <div class="col-lg-10">
                      <input placeholder="00:00" class="form-control w-full-xs w-xs" type="time"
                             v-model="horaPublicacao" v-mask="'##:##'"/>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Data de Abertura</label>
                    <div class="col-lg-10">
                      <input placeholder="dd/mm/yyyy" class="form-control w-full-xs w-sm " v-model="dataAbertura"
                             v-mask="'##/##/####'"/> <input type="checkbox" v-model="leilao.semData"> Sem data
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Hora de Abertura</label>
                    <div class="col-lg-10">
                      <input placeholder="00:00" class="form-control w-full-xs w-xs" type="time"
                             v-model="horaAbertura" v-mask="'##:##'"/>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Automático</label>
                    <div class="col-lg-10">
                      <div class="checkbox">
                        <label class="i-checks">
                          <input type="checkbox" v-model="leilao.automatico"><i></i>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Loteado</label>
                    <div class="col-lg-10">
                      <div class="checkbox">
                        <label class="i-checks">
                          <input type="checkbox" v-model="leilao.loteado"><i></i>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Tempo do Pregão</label>
                    <div class="col-lg-10">
                      <input id="timerPregao" placeholder="" type="number" v-model="leilao.timerPregao"
                             v-mask="'########'" class="form-control inline m-r-xs w-xs"
                      /> segundos
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-lg-offset-2 col-lg-10">
                      <span class="help-block m-b-none">Leiloeiro</span>
                    </div>
                  </div>
                  <div class="line line-dashed b-b line-lg pull-in"></div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Leiloeiro</label>
                    <div class="col-lg-10">
                      <select v-model="leilao.leiloeiro" class="form-control w-auto w-full-xs">
                        <option disabled value="">{{loadTiposText}}</option>
                        <option v-for="leiloeiro in leiloeiros" v-bind:value="leiloeiro.id">
                          {{ leiloeiro.nome }}
                        </option>
                      </select>
                      <a v-if="loadTiposError" class="btn text-danger" @click="loadTipos">Não foi possível carregar. Tente novamente</a>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Comissão</label>
                    <div class="col-lg-10">
                      <input type="number" class="form-control inline w-xxs" v-model="leilao.valorComissao" size="5"> %
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-lg-10 col-lg-offset-2">
                      <div class="checkbox">
                        <label class="i-checks">
                          <input type="checkbox" v-model="leilao.cobraComissao"><i></i> Cobrar comissão
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group m-t-lg">
                    <div class="col-lg-offset-2 col-lg-10">
                      <span class="help-block m-b-none">Financeiro</span>
                    </div>
                  </div>
                  <div class="line line-dashed b-b line-lg pull-in"></div>

                  <div class="form-group">
                    <div class="col-lg-10 col-lg-offset-2">
                      <div class="checkbox">
                        <label class="i-checks">
                          <input type="checkbox" v-model="leilao.cobraTaxasAdicionais"><i></i> Cobrar taxas
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Taxa ICMS</label>
                    <div class="col-lg-10">
                      <input type="number" class="form-control inline w-xxs" v-model="leilao.valorTaxaIcms" size="5"> %
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Taxa ISS</label>
                    <div class="col-lg-10">
                      <input type="number" class="form-control inline w-xxs" v-model="leilao.valorTaxaIss" size="5"> %
                    </div>
                  </div>

                  <div class="form-group m-t-lg">
                    <div class="col-lg-offset-2 col-lg-10">
                      <span class="help-block m-b-none">Sistemas integrados</span>
                    </div>
                  </div>
                  <div class="line line-dashed b-b line-lg pull-in"></div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">ID Interno</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.syncId">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Nº Leilão Interno</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.syncExtra.codigoInterno">
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-12">
                  <div class="form-group">
                    <div class="col-lg-offset-2 col-lg-10">
                      <span class="help-block m-b-none">Informações sobre o leilão</span>
                    </div>
                  </div>
                  <div class="line line-dashed b-b line-lg pull-in"></div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Título</label>
                    <div class="col-lg-10">
                      <input type="text" v-model="leilao.titulo" class="form-control"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Descrição</label>
                    <div class="col-lg-10">
                  <textarea class="form-control" v-model="leilao.descricao" rows="5"
                            style="resize: none"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Informação de Visitação</label>
                    <div class="col-lg-10">
                  <textarea class="form-control" v-model="leilao.infoVisitacao" rows="5"
                            style="resize: none"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Informação de Retirada</label>
                    <div class="col-lg-10">
                  <textarea class="form-control" v-model="leilao.infoRetirada" rows="5"
                            style="resize: none"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Observações</label>
                    <div class="col-lg-10">
                  <textarea class="form-control" v-model="leilao.observacao" rows="5"
                            style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Imagem Destaque</label>
                    <div class="col-lg-10">
                      <input type="file" id="fotoDestaque">
                      <div v-if="leilao.fotoDestaque">
                        <img :src="leilao.fotoDestaqueUrl" style="max-width: 100%">
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-lg-2 control-label">Habilitar Imagem Destaque</label>
                    <div class="col-lg-10">
                      <input type="checkbox" v-model="leilao.habilitarFotoDestaque">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Descricão em Destaque</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.descricaoDestaque">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Cor do texto em Destaque</label>
                    <div class="col-lg-10">
                      <input type="color" class="form-control w-sm w-full-xs" v-model="leilao.descricaoDestaqueConfig.cor"> <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.descricaoDestaqueConfig.cor">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Tamanho da fonte em Destaque</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.descricaoDestaqueConfig.fonte">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Subdescricão em Destaque</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.descricaoDestaque2">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-lg-2 control-label">Texo do Botão</label>
                    <div class="col-lg-10">
                      <input type="text" class="form-control w-sm w-full-xs" v-model="leilao.descricaoBotao">
                    </div>
                  </div>

                </div>
              </div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!leilao.id">Cadastrar</span>
                  <span v-if="leilao.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default">Cancelar</u-button>
                <span v-if="!leilao.id">Ao cadastrar, o status do leilão será <span class="text-info">Rascunho</span>, para publicá-lo, altere o status após o cadastro.</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// NovoLeilao.vue?3a24a68d